
export enum RoutesSearch {
  //Получение МНН синонимов
  GetSynonyms='/patent-search/mnn-synonyms',
  //Получение МНН синонимов
  PostMNNAndSynonyms='/patent-search/patents',
  //Получение МНН синонимов в autocomlite
  GetAutoMNN='/patent-search/get-auto-mnn',
  //Получение таблиц
  GetGroupingTable='/grouping-tables/list',
  //Сохранение отчета
  PostSaveReport='/report/save',
  PostSaveJsonReport='/report/save-json-report',
  //Получение активных сессий
  GetActiveSessions = "/sessions/active",
  //Удаление патентов
  PostDeleteDocuments = "/patents/remove-documents",
  //Знак ?
  PostSetQuestions = "/patents/set-question-mark",
  //Получение 2 шаблона
  GetTemplate = "/search-result-template/volume_template",
  //Получение данных по сессии
  GetSaveSessionData = "sessions/session-patents",
  GetSessionRefreshMnn = "/patent-search/session-mnn-synonyms",
  GetSessionSourceStatuses = "/sessions/source-statuses",
  PostSaveCheckPatents = "/patents/save-is-checked",
  GetTemplates = "/search-result-template/identification/",
  PostRestart = "/sessions/restart",
}
